import React from "react"
import { ExternalLink } from "components"

export default {
  label: "Stay",
  title: <>Where to Stay</>,
  body: (
    <div>
      <p>
        Black in Design has negotiated a great discounted rate for our attendees
        of $219 per night (plus taxes) at the{" "}
        <ExternalLink url="https://www.hotelstudioallston.com">
          Studio Allston Hotel
        </ExternalLink>
        . Studio Allston Hotel is located just across the river from Harvard
        Square in the Barry’s Corner area, at 1234 Soldiers Field Road, Boston,
        MA 02135 (tel. 617-206-1848).{" "}
        <ExternalLink url="https://hotelstudioallston.reztrip.com/ext/promoRate?property=1604&mode=b&pm=true&sr=506478&vr=3&accessCode=GSDHAR">
          Reserve your room in the Harvard GSD discounted block
        </ExternalLink>
        .
      </p>
      <p>
        Guests staying at Studio Allston can take public transit, cabs, or
        ride-shares to quickly get to the BiD conference venue at Gund Hall (48
        Quincy St., Cambridge, MA 02138). The{" "}
        <ExternalLink url="https://www.mbta.com/schedules/86/line">
          MBTA #86
        </ExternalLink>{" "}
        bus has a stop right by the hotel at the corner of Western Ave. and
        Everett St., and a stop at Gund Hall. The{" "}
        <ExternalLink url="https://www.mbta.com/schedules/66/line">
          MBTA #66
        </ExternalLink>{" "}
        bus goes from Barry’s Corner to Harvard Square. Note that bus schedules
        vary for weekdays, Saturday, and Sunday. The{" "}
        <ExternalLink url="https://transitapp.com/">Transit app</ExternalLink>{" "}
        is a good resource to check real-time bus arrivals.
      </p>
      <p>
        If you’d like to be closer to Gund Hall, there are several hotels in
        Harvard Square, and a few B&amp;Bs, within about 10 minutes walking
        distance:
      </p>
    </div>
  ),
  hotels: [
    {
      name: "The Hotel Veritas",
      url: "http://www.thehotelveritas.com/",
      address: "One Remington St, Cambridge, MA 02128",
      phone: "617-520-5000",
    },
    {
      name: "Harvard Square Hotel",
      url: "http://www.harvardsquarehotel.com/",
      address: "110 Mt. Auburn St, Cambridge, MA, 2138",
      phone: "617-864-5200 or 1-800-458-5886",
    },
    {
      name: "The Charles Hotel",
      url: "http://www.charleshotel.com/",
      address: "One Bennett St, Cambridge, MA 02138",
      phone: "617-864-1200 or 1-800-882-1818",
    },
    {
      name: "Sheraton Commander Hotel",
      url: "http://www.sheratoncommander.com/",
      address: "16 Garden St, Cambridge, MA 02138",
      phone: "617-547-4800 or 1-800-535-5007",
    },
    {
      name: "Irving House",
      url: "http://irvinghouse.com/",
      address: "24 Irving St, Cambridge, MA 02138",
      phone: "617-547-4699 or 877-547-4600",
    },
    {
      name: "A Friendly Inn at Harvard",
      url: "http://www.afinow.com/afi/",
      address: "1673 Cambridge St, Cambridge, MA 02138",
      phone: "617-547-7851",
    },
    {
      name: "Parkside on Ellery B&B",
      url: "https://parksidebb.com/",
      address: "74 Ellery St., Cambridge, MA 02138",
      phone: "617-492-5025",
    },
  ],
  additionalHotels: {
    intro: (
      <>
        <h3>Additional Lodging</h3>
        <p>
          More options in the area (most easily accessible to Gund Hall by
          public transit or cab/rideshare) include:
        </p>
      </>
    ),
    hotels: [
      {
        name: "The Mary Prentiss Inn",
        url: "http://maryprentissinn.com/",
        address: "6 Prentiss St, Cambridge, MA 02140",
        phone: "617-661-2929",
      },
      {
        name: "DoubleTree Suites by Hilton Hotel Boston - Cambridge",
        url: "http://bit.ly/BOSSBHarvard",
        address: "400 Soldiers Field Road, Boston, MA 02134",
        phone: "617-783-0090 or 1-800-754-7515",
      },
      {
        name: "Courtyard by Marriott Boston/Cambridge",
        url:
          "http://www.marriott.com/hotels/travel/boscy-courtyard-boston-cambridge/",
        address: "777 Memorial Dr, Cambridge, MA 02139",
        phone: "617-492-7777",
      },
      {
        name: "Porter Square Hotel",
        url: "http://www.theportersquarehotel.com/",
        address: "1924 Massachusetts Ave, Cambridge, MA 02140",
        phone: "617-499-3399",
      },
      {
        name: "Le Meridien Cambridge-MIT",
        url: "http://www.lemeridiencambridgemit.com/",
        address: "20 Sidney St, Cambridge, MA 02139",
        phone: "617-577-0200 or 866-716-8119",
      },
      {
        name: "A Cambridge House",
        url: "http://www.acambridgehouse.com/",
        address: "2218 Massachusetts Ave, Cambridge, MA, 02140",
        phone: "617-491-6300 or 1-800-232-9989",
      },
      {
        name: "The Kendall Hotel",
        url: "https://www.kendallhotel.com/",
        address: "350 Main St, Cambridge, MA 02142",
        phone: "617-577-1300 or 866-566-1300",
      },
      {
        name: "The Freepoint Hotel",
        url: "https://www.freepointhotel.com/",
        address: "220 Alewife Brook Parkway, Cambridge, MA, 02138",
        phone: "617-491-8000 or 1-855-752-2005",
      },
      {
        name: "Hyatt Regency Cambridge",
        url: "https://cambridge.regency.hyatt.com/en/hotel/home.html",
        address: "575 Memorial Dr, Cambridge, MA 02139",
        phone: "617-492-1234 or 1-800-233-1234",
      },
      {
        name: "Boston Marriott Cambridge",
        url:
          "http://www.marriott.com/hotels/travel/boscb-boston-marriott-cambridge/",
        address: "50 Broadway, Cambridge, MA 02142",
        phone: "617-494-6600 or 1-800-228-9290",
      },
      {
        name: "Holiday Inn Express Hotel & Suites Boston - Cambridge",
        url: "http://www.ihg.com/holidayinnexpress/hotels/us/en/reservation",
        address: "250 Monsignor O'Brien Highway, Cambridge, MA 02141",
        phone: "617-577-7600",
      },
      {
        name: "Homewood Suites by Hilton",
        url:
          "http://homewoodsuites3.hilton.com/en/hotels/massachusetts/homewood-suites-by-hilton-boston-cambridge-arlington-ma-BOSARHW/index.html",
        address: "1 Massachusetts Ave, Arlington, MA 02474",
        phone: "781-643-7258",
      },
      {
        name: "Royal Sonesta",
        url: "http://www.sonesta.com/boston",
        address: "40 Edwin H Land Blvd, Cambridge, MA 02142",
        phone: "617-806-4200",
      },
      {
        name: "AC Hotel by Marriott - Cambridge",
        url: "http://www.achotelbostoncambridge.com/",
        address: "10 Acorn Park Dr, Cambridge, MA 02140",
        phone: "617-876-6190",
      },
    ],
  },
}
